<template lang="pug">
.custom-toggle-button-group-wrapper
  .btn-group(data-toggle="buttons")
    .form-group
      label.control-label(v-if="label")
        .d-flex.align-items-center
          | {{ label }}
          i.hi.hi-12.a-tooltip.mx-5(
            v-if="labelTooltip"
            v-tooltip="tooltipOptions"
            :class="tooltipClass"
            :title="disabled ? disabledTooltip : labelTooltip"
          )

      .d-flex.align-items-center.justify-content-start.toggle-multiple-options
        AppToggleButton(
          v-for="item in items"
          :key="item.id"
          :value="item.value"
          :text="item.text"
          :disabled="disabled"
          :selected="isSelected(item)"
          @input="onInput"
        )
</template>

<script>
import vModelCompat from '~/mixins/v_model_compat';

export default {
  name: 'AppToggleButtonGroup',
  mixins: [vModelCompat],
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    labelTooltip: {
      type: String,
      default: '',
    },
    tooltipOptions: {
      type: Object,
      required: false,
      default: () => ({
        placement: 'top',
      }),
    },
    selected: {
      type: [String, Number, Boolean],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTooltip: {
      type: String,
      default: undefined,
    },
    tooltipClass: {
      type: String,
      default: 'hi-info-filled',
    },
  },
  computed: {
    currentValue() {
      if (this.selected !== undefined) {return this.selected;}

      return this.modelCompatValue;
    },
  },
  methods: {
    onInput(event) {
      this.emitModelCompatValue(event);
    },
    isSelected(item) {
      return this.currentValue === item.value;
    },
  },
};
</script>
